import { useCallback, useMemo } from 'react'

import LoyaltySocietePointsFilterGroup from 'loyalty/components/LoyaltySocietePointsFilterGroup'
import useExperiencesSearchFilters from 'components/Experiences/hooks/useExperiencesSearchFilters'
import useTrackExperienceSearchFilter from 'components/Experiences/hooks/useTrackExperienceSearchFilter'
import getIsExperienceLoyaltyBurnEnabled from 'loyalty/selectors/getIsExperienceLoyaltyBurnEnabled'
import { useAppSelector } from 'hooks/reduxHooks'
import { getExperienceSearchBurnCalculationKey } from 'lib/experiences/getExperienceSearchBurnCalculationKey'
import usePrefetchExperienceSearchBurnCalculations from '../hooks/usePrefetchExperienceSearchBurnCalculations'

interface Props {
  listIds?: Array<string>
}

function ExperienceSearchSocieteFilters({ listIds }: Props) {
  const isBurnEnabled = useAppSelector(getIsExperienceLoyaltyBurnEnabled)
  const { searchFilters, setSearchFilters } = useExperiencesSearchFilters()
  const trackSearchFilter = useTrackExperienceSearchFilter()
  usePrefetchExperienceSearchBurnCalculations(listIds)

  const viewPriceInPoints = !!searchFilters.viewPriceInPoints
  const experienceSearchKey = useMemo(
    () => getExperienceSearchBurnCalculationKey(searchFilters),
    [searchFilters],
  )

  const handleViewPriceInPointsChange = useCallback((nextViewPriceInPoints: boolean) => {
    trackSearchFilter({
      label: 'View Price in Points',
      type: 'view_price_in_points',
      value: nextViewPriceInPoints ? 'selected' : 'unselected',
    })
    setSearchFilters({ ...searchFilters, viewPriceInPoints: nextViewPriceInPoints || undefined })
  }, [searchFilters, setSearchFilters, trackSearchFilter])

  if (!isBurnEnabled) {
    return null
  }

  return (
    <LoyaltySocietePointsFilterGroup
      compact
      cacheKey={experienceSearchKey}
      skipBatchMaxCap
      skipBurnExperiment
      viewPriceInPoints={viewPriceInPoints}
      onViewPriceInPointsChange={handleViewPriceInPointsChange}
      enableBurnControls={isBurnEnabled}
    />
  )
}

export default ExperienceSearchSocieteFilters
